import React, { Fragment, useEffect, useState } from "react";
import { Grid, Skeleton } from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import GirlIcon from '@mui/icons-material/Girl';
import BoyIcon from '@mui/icons-material/Boy';
import { PieChart, ColumnChart } from '../../../../components/charts';
import { InfluencerProfileService } from '../../../../core/services/influencer-profile.service';
import { ListService, LocalService, UserService } from '../../../../core/services';
import { DefaultUserProfile } from '../../../../config/config';
import { ResponseType } from "custom-type";
import { connect } from "react-redux";
import { Loading, UserLogin } from "../../../../redux/action";
import { HandlesService } from "../../../../core/services/handles.service";
import InstagramIcon from "../../../../components/icons/instagram-icon";
import { CreateCampaign as CampaignService } from "../../../../core/services";
import { FormValidation, Methods } from "../../../../core/utility";
import { Link, NavLink } from 'react-router-dom';
import InsightMediaDetailCard from './../post-card';
import InsightMediaReelsCard from './../reels-card';
import InsightMediaCarouselCard from './../carousel-card';
import InsightMediaImageCard from './../image-card';
import CityList from './../city-list';
import { LineChartDropDown } from "../../../../components/charts/line-chart";
import AddToCampaign from "../../../../components/add-to-campaign/add-to-campaign";
import AddToList from "../../../../pages/brand/discover/add-to-list";
import UpgradeBrandPopUp from "../../../../components/popup/upgrade-brand-popup";
import InfluencerProfileLeft from "./../influencer-profile-left";
import FollowerCard from "./../follower-card";
import FollowerCardInline from "./../follower-card-inline";
import FollowerSection from "./../followers/follower-sec";
import FollowerSecInline from "./../followers/follower-sec-inline";
import PostFrequency from "./../followers/post-frequency";
import Audience from "./../audience/audience";
import Engagement from "./../engagement/engagement";
import InstagramIcon1 from "../../../../components/icons/instagram-icon1";
import { useNavigate } from "react-router-dom";
import InsightMediaLatestPostCard from "./../latest-post"
import useBodyClass from "../../../../hooks/useBodyClass";
import * as gtUtil from "../../../../core/utility";
import { toast } from "react-toastify";
import SocialConnectRestriction from '../../../../components/popup/social-connect-restrict';
import ContentLoading from "../../../../components/loader/loading";
import Tooltip from "@mui/material/Tooltip";
import dayjs from "dayjs";
import moment from "moment";
import { AdvancedColumnChart } from "../../../../components/charts/advanced-column-chart";
import InfluencerProfileLeftFB from "./influencer-profile-left-fb";
import { FacebookIcon } from "react-share";
import { Facebook } from "@mui/icons-material";

const inflProfileService: InfluencerProfileService = new InfluencerProfileService()
const handlesService = new HandlesService();
const methods = new Methods();

interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  getSubscriptionDetail: any;
  updateUser: any;
}


const listService: ListService = new ListService()
const userService = new UserService();

const ProfileInsightFB: React.FC<Props> = (props: Props) => {
  const [profile_id] = useState(() => {
    const idString = new URLSearchParams(window.location.search).get('profile_id');
    return idString ? parseInt(idString, 10) : 0;
  });

  const [selectInflu, setSelectInflu] = useState<any>([]);
  const [influencerData, setInfluencerData] = useState<any>([]);
  const [genderSplitPieChartData, setGenderSplitPieChartData] = useState<any[]>([]);
  const [loading, setIsLoading] = useState(false)
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [columnChartData, setColumnChartData] = useState<any[]>([]);
  const [genderArrayLabel, setGenderArrayLabel] = useState()
  const [postErComparisonData, setPostErComparisonData] = useState<any[]>([]);
  const [influencerList, setInfluencerList] = useState<any>(null);
  const [value, setValue] = useState("1");
  const [showPopAddToCampaign, setShowPopAddToCampaign] = useState(false);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const [showAddToListPopup, setShowAddToListPopup] = useState(false);
  const [openUpgradeBrandModal, setOpenUpgradeBrandModal] = useState<boolean>(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [location, setLocation] = useState('');
  const [categories, setCategories] = useState([]);
  const [language, setLanguages] = useState([]);
  const [subscription_status, setSubscription_status] = useState<any>({
    status: null,
    plan_start_date: null,
    plan_end_date: null
  });
  const [connected_profile, set_connected_profile] = useState<Boolean>(false);
  const [connect, setConnect] = useState<Boolean>(false);
  const [fb_connected, setFb_connected] = useState<Boolean>(false);
  const [error_msg_mismatch, set_error_message_mismatch] = useState<Boolean>(false);

  const navigate = useNavigate();
  const utCapitals:any = {
    "Andaman and Nicobar Islands": "Port Blair",
    "Chandigarh": "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu": "Daman",
    "Delhi": "New Delhi",
    "Jammu and Kashmir": "Srinagar (Summer), Jammu (Winter)",
    "Ladakh": "Leh",
    "Lakshadweep": "Kavaratti",
    "Puducherry": "Puducherry"
  };
  // to get connected instagram account sm_id
  async function getConnectedAccountId(influencer_id: number | string) {
    try {
      const res: any = await handlesService.getConnectedAccountsIgFb(influencer_id, props.UserReducer.account_type);
      if (res?.data?.rows.length > 0) {
        if(res.data.rows[0].token_status === 'Connected') {
          setFb_connected(true);
        }
        const connectedAccountData = res.data.rows.filter(
          (filter: any) => (filter.account_type === 'Primary' || filter.ig_account_type === 'Primary') || (props.UserReducer.account_type === 'Talent Partner' && (filter.account_type === 'Secondary' || filter.ig_account_type === 'Secondary'))
        );
        if (connectedAccountData.length > 0) {
          return connectedAccountData[0].ig_id;
        }
      }

    } catch (err: any) {
      console.error('Error fetching connected accounts:', err);
      // Handle the error as needed...
    }

    // Return a default value or handle the case when no connected account is found
    return null;
  }

  useEffect(() => {
    const fetchData = async () => {
      let idToSet;
      try {
        if (urlParams.get("sm_id") == null) {
          idToSet = await getConnectedAccountId(props?.UserReducer?.influencer_id);
        } else {
          idToSet = urlParams.get("sm_id");
        }
      } catch (error) {
        console.error('Error setting Instagram ID:', error);
      }

      // Continue with other logic after setting Instagram ID
      getProfileInsight(idToSet);
    };

    fetchData();
  }, [connect]);

  useEffect(() => {

  }, [props.getSubscriptionDetail])
  const [dataInitialized, setDataInitialized] = useState(false);
  //3rd chart
  const getProfileInsight = async (instagramID: any) => {
    setIsLoading(true)
    setDataInitialized(false);
    try {

      let response;
      if (props?.UserReducer?.account_type === 'Brand' || props?.UserReducer?.account_type === 'Agency') {
        response = await inflProfileService.getBrandProfileFB({
          url_id: profile_id,
          
        });
       
      } 

      if (response.status === gtUtil.Constants.SUCCESS) {
        set_connected_profile(false);
        setInfluencerData(response?.data?.rows); 
        setIsLoading(false);
        //Post Est Reach Comparison Data

        const erComparisonData = response?.data?.rows?.detail;
        if (Array.isArray(erComparisonData)) {
          let imageArray = ((erComparisonData[0]?.image_posts_est_reach_comparison + erComparisonData[0]?.carousel_posts_est_reach_comparison) / 2) || 0;
          let reelArray = erComparisonData[0].reels_posts_est_reach_comparison || 0;
          // let carouselArray = erComparisonData[0]?.carousel_posts_est_reach_comparison ? erComparisonData[0]?.carousel_posts_est_reach_comparison : 0;
          const postErData = [

            {
              name: "Images",
              type: "column",
              groupPadding: 0.8,
              data: [{
                name: 'image',
                value: imageArray
              }],
              color: "#0A7447",
            },
            {
              name: "Reels",
              type: "column",
              groupPadding: 0.8,
              data: [{
                name: 'reel',
                value: reelArray
              }],
              color: "#34E098",
            },
            // {
            //   name: "Carousel",
            //   type: "column",
            //   groupPadding: 0.8,
            //   data: [{
            //     name: 'carousel',
            //     value: carouselArray
            //   }],
            //   color: "#5da8b0",
            // },
          ];

          setPostErComparisonData(postErData);
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }
      }else{
        if(response.status === gtUtil.Constants.DB_QUERY_NO_RECORD_FOUND){
          set_connected_profile(true);
        }
      }
    } catch (error) {
      console.log(`inflProfileService error :: ${JSON.stringify(error)}`);
    } finally {
      setIsLoading(false);
      setDataInitialized(true); 
    }
  }

  useEffect(() => {
    _InfluencerList();

  }, [props.UserReducer.brand_id, props.UserReducer.user_id]);



  useEffect(() => {
    const bodyElement = document.getElementsByTagName('body')[0];
    if (bodyElement) {
      if (showAddToListPopup || showPopAddToCampaign) {
        bodyElement.classList.add("overflow-hidden", "overlay");
      } else {
        bodyElement.classList.remove("overflow-hidden", "overlay");
      }
    } else {
      console.error("Body element not found!");
    }
  }, [showAddToListPopup, showPopAddToCampaign]);



  function _InfluencerList() {
    CampaignService.influencerList({
      user_id: props.UserReducer.user_id,
      brand_id: props.UserReducer.brand_id,
    }).then((res: any) => {
      if (res.data.status === 1) {
        setInfluencerList(res.data.rows);
      } else {
        setInfluencerList(null);
      }
    });
  }


  useBodyClass("page-profile-insight")
  
  const [social_loader, set_social_loader] = useState<boolean>(false);
    const [loadingInstagram, setLoadingInstagram] = React.useState(false);
    
        const [instagramAccount, setInstagramAccount] = React.useState<any>([]);
           const [ig_data, set_ig_data] = useState({});
            const [yt_data, set_yt_data] = useState({});
               const [socialRestrictionPopup, set_socialRestrictionPopup] = useState({
                    youtube: false,
                    instagram: false
                })
  async function getInstagramAccounts() {
    try{
    setLoadingInstagram(true)
    handlesService
        .getConnectedInstagramAccounts(
            props?.UserReducer?.influencer_id
        )
        .then((res: any) => {
            if (res?.data?.rows.length > 0) {
                setInstagramAccount(res?.data?.rows);
            }
        })
        .catch((err: any) => {
            console.log(err)
            setLoadingInstagram(false)
        })}catch(err){
            console.log(err)
            setLoadingInstagram(false)
        }finally{
            setLoadingInstagram(false)
        }
}
        const instagramConnect = async () => {
          try {
            const response = await handlesService.instagramConnect();
        
            if (response.status === gtUtil.Constants.SUCCESS) {
              const popup = window.open(
                response.data.url,
                "InstagramOAuthPopup",
                "width=500,height=600,left=100,top=100"
              );
        
              if (!popup) {
                toast.error("Popup blocked. Please allow popups and try again.");
                return;
              }
        
              const channel = new BroadcastChannel('oauth-channel');
              channel.onmessage = async (event) => {
                if (event.data?.type === 'social-auth-success') {
                  const authCode = event.data.code;
                  channel.close();
        
                  try {
                    set_social_loader(true);
        
                    const response = await handlesService.postInstagramConnect({
                      code: authCode,
                      influencer_id: props.UserReducer.influencer_id,
                    });
        
                    if (response.status === gtUtil.Constants.SUCCESS) {
                      updateUserReducer();
                      getInstagramAccounts();
                      setConnect(!connect);
                    } else if (response.info === 'Social account already connected to the other account.') {
                      set_ig_data(response.data);
                      set_socialRestrictionPopup(prev => ({
                        ...prev,
                        instagram: true,
                      }));
                    }
                  } catch (err) {
                    console.error("Error posting Instagram auth code:", err);
                    toast.error("Instagram authentication failed.");
                  } finally {
                    set_social_loader(false);
                  }
                }
              };
            } else {
              console.error("Error fetching Instagram OAuth URL:", response.info);
              toast.error("Failed to get Instagram authentication URL.");
            }
          } catch (error) {
            console.error("Instagram Connect Error:", error);
            toast.error("Instagram login failed");
          } finally {
            set_social_loader(false);
          }
        };
        async function updateUserReducer() {
          let latestUserReducerData = await userService.getUpdatedUserReducer(props.UserReducer);
          if (![undefined, null, ''].includes(latestUserReducerData)) {
              props.updateUser(latestUserReducerData)
          }
      }
  return (
    <Fragment>
      {!dataInitialized ? <ContentLoading width="125" height="125" />  :
      ((props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner') && connected_profile) ? (
        <div style={{ textAlign: "center" }}>
        Please <span style={{borderBottom:'1px solid #2b2b2b', cursor:'pointer', fontWeight:'bold'}} onClick={instagramConnect}>verify</span> your Instagram account to retrieve the profile.
      </div>
      ) : (
            <div className="container">
              <div className="influencer-profile">
                <div className="influencer-profile__left">
                  <InfluencerProfileLeftFB influencerData={influencerData} email={email} phone={phone} location={location} language={language} category={categories} loading={loading} subscription_status={subscription_status} />
                </div>
                <div className="influencer-profile__right">
                  <div className="d-flex flex-wrap w-100 align-items-center mb-3">
                    <div className="d-none d-lg-flex align-items-center">
                      {influencerData?.profile_detail?.username && <Facebook />}
                      <Link target="_blank" className="btn btn-text-link" to={`${influencerData?.profile_detail?.profile_url}`}>
                        <span>{influencerData?.profile_detail?.username}</span>
                      </Link>
                   
                    </div>
                    <span className='profile-updated'>{`Last updated on 
                      ${dayjs(influencerData.updated_at).format("MMM D, YYYY")}`}
                    </span>
                    
                  </div>
                  
                  <div className="followers-info d-none d-md-flex flex-column">
                    
                    {/* FOLLOWERS SECTION */}
                    <FollowerSection loading={loading} influencerData={influencerData} />
                    {/* FOLLOWERS SECTION ENDS */}
                  
                  
                  
                  </div>
                 
                
            
                </div>
              </div>
            </div>
      )}
     
    </Fragment >
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
    getSubscriptionDetail: state.Subscription.subscription_detail
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    updateUser: (data: any) => dispatch(UserLogin(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(ProfileInsightFB);

export { connectToRedux as ProfileInsightFB };